<article
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="sessionRevokedTitle"
  class="tw-relative tw-flex tw-flex-col tw-bg-white tw-text-center"
>
  <h2 id="sessionRevokedTitle" class="tw-mb-6 tw-text-2xl tw-font-semibold tw-text-gray-900">
    {{ 'session_revoked.title' | translate }}
  </h2>

  <p class="tw-text-main-text">{{ 'session_revoked.message' | translate }}</p>
  <p class="tw-mt-4 tw-text-main-text">{{ 'session_revoked.hint' | translate }}</p>

  <section class="tw-mt-8 tw-flex tw-justify-center">
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'commons.close' | translate"
      [width]="160"
      (clicked)="close()">
    </mh-core-lib-button>
  </section>
</article>
